import React, { useState, useEffect } from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  TextField, 
  Button, 
  Typography, 
  Box, 
  Alert,
  IconButton
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { setApiKey, isApiKeyConfigured } from '../services/aiService';

function Settings({ open, onClose }) {
  const [apiKey, setApiKeyState] = useState('');
  const [showKey, setShowKey] = useState(false);
  const [configured, setConfigured] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setConfigured(isApiKeyConfigured());
    // 不直接获取密钥显示，仅检查是否已设置
  }, [open]);

  const handleSave = () => {
    if (!apiKey && !isApiKeyConfigured()) {
      setError('请输入API密钥');
      return;
    }
    
    if (apiKey) {
      setApiKey(apiKey);
      setConfigured(true);
    }
    
    setApiKeyState('');
    setShowKey(false);
    setError('');
    onClose();
  };

  const handleCancel = () => {
    setApiKeyState('');
    setShowKey(false);
    setError('');
    onClose();
  };

  const handleReset = () => {
    setApiKey('');
    setConfigured(false);
    setApiKeyState('');
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>系统设置</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 3, mt: 1 }}>
          <Typography variant="subtitle1" gutterBottom>
            配置OpenAI Router API密钥
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            需要使用OpenAI Router的API密钥来生成代码挑战和评估代码。
            您可以在<a href="https://openrouter.ai/" target="_blank" rel="noopener noreferrer">OpenRouter网站</a>获取API密钥。
          </Typography>
          
          {configured && (
            <Alert severity="success" sx={{ mb: 2 }}>
              已配置API密钥
            </Alert>
          )}
          
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          
          <TextField
            fullWidth
            label="API密钥"
            variant="outlined"
            value={apiKey}
            onChange={(e) => setApiKeyState(e.target.value)}
            type={showKey ? 'text' : 'password'}
            sx={{ mb: 1 }}
          />
          
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Button 
              size="small" 
              onClick={() => setShowKey(!showKey)}
              sx={{ mr: 1 }}
            >
              {showKey ? '隐藏' : '显示'}
            </Button>
            
            {configured && (
              <Button 
                color="error" 
                size="small" 
                onClick={handleReset}
              >
                重置密钥
              </Button>
            )}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>取消</Button>
        <Button onClick={handleSave} variant="contained">保存</Button>
      </DialogActions>
    </Dialog>
  );
}

// 设置按钮组件
export function SettingsButton({ onClick }) {
  return (
    <IconButton color="inherit" onClick={onClick} title="设置">
      <SettingsIcon />
    </IconButton>
  );
}

export default Settings; 